import { AutomationTask, TabProxy, TaskRecorder } from "encampy";

/**
 * Creates an automation plan by running the provided automation function
 * and returning the recorded tasks. This hides the TaskRecorder/TabProxy
 * implementation details from the caller.
 */
export function createAutomationPlan(
  automate: (tab: TabProxy) => Promise<void>
): Promise<AutomationTask[]> {
  return new Promise(async (resolve, reject) => {
    try {
      const recorder = new TaskRecorder();
      const tab = new TabProxy(recorder);

      await automate(tab);

      resolve(recorder.getTasks());
    } catch (error) {
      reject(error);
    }
  });
}
